import { Component, EventEmitter, Input, OnChanges, OnInit, OnDestroy, Output, SimpleChanges, ChangeDetectorRef, HostListener } from '@angular/core';
import { CommonModule, KeyValuePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import * as _ from 'lodash';
declare const Helpers: any;

import { WorkflowDatasourceService } from '../../services/workflow-datasource/workflow-datasource.service';
import { DynamicFormActionSetupComponent } from './sub-components/dynamic-form-action-setup/dynamic-form-action-setup.component';
@Component({
  selector: 'dynamic-action-form-renderer',
  templateUrl: './dynamic-action-form-renderer.component.html',
  styleUrl: './dynamic-action-form-renderer.component.scss',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HttpClientModule, KeyValuePipe, DynamicFormActionSetupComponent]
})
export class DynamicActionFormRendererComponent implements OnInit, OnChanges, OnDestroy {
  @Input() schema: any | null = null;
  @Input() data: any | null = null;
  @Input() readonly: boolean = true;

  @Output() submit = new EventEmitter<any>();
  @Output() reset = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();

  constructor(
    private cdr: ChangeDetectorRef,
    private _workflowDatasource: WorkflowDatasourceService
  ) {
  }



  keepOrder = () => 0;


  formTitle: string = ''
  submitLabel: string = "Save"
  resetLabel: string = "Reset"
  schemaHash: any = {};
  dataHash: any = {};
  sections: any = [];
  isSchemaAvailable: boolean = false;
  selectedTabType: string = 'basic';
  defaultDataObject: any = {};
  private previousEventName: string | null = null;
  conditionsV2Enabled: boolean = false;
  schemaType: string = '';
  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schema']) {
      this.schemaHash = _.cloneDeep(this.schema);
      this.conditionsV2Enabled = !!_.get(this.schema, 'conditionsV2Enabled');
      this.schemaType = _.get(this.schema, 'schema_type', '');
    }

    // If defaultValues change and form is already initialized, re-apply them
    if (changes['data']) {
      this.dataHash = _.cloneDeep(this.data);
      this.previousEventName = this.dataHash?.event_name || null;
      this.previousAppliesToValue = this.dataHash?.applies_to;
    }
    this.currentSectionIndex = 0;
    this.initFormRenderer(_.cloneDeep(this.schema), _.cloneDeep(this.data));
  }

  initFormRenderer(schema: any, data: any) {
    this.formTitle = _.get(schema, 'title', '');
    this.conditionsV2Enabled = !!_.get(schema, 'conditionsV2Enabled');
    if (!_.isEmpty(schema) && _.hasIn(schema, 'sections') && !_.isEmpty(schema.sections)) {
      this.sections = _.get(schema, 'sections', []);
    }
    if (this.sections.length > 1) {
      this.renderSchema(0);
    } else {
      this.renderSchema();
    }

    this.cdr.detectChanges();
  }

  fieldOptions: any = []
  rulesetHash: any = {}
  fieldDefsMap: any = {}
  renderSchema(index?: number) {
    this.fieldOptions = []
    if (typeof index == 'number' && index >= 0 && this.sections.length > 1) {
      const selectedSection = this.sections[index];
      this.selectedTabType = (selectedSection && selectedSection.type && selectedSection.type != '') ? selectedSection.type : 'basic'
      if (selectedSection && selectedSection.type && !_.isEmpty(this.schema) && _.hasIn(this.schema, selectedSection.type + '.properties') && !_.isEmpty(this.schema[selectedSection.type].properties)) {
        this.schemaHash = _.cloneDeep(this.schema[selectedSection.type]);
        if (selectedSection.type == 'conditions') {
          this.fieldOptions = _.get(this.schemaHash, 'properties.rulesetlist', [])
          this.rulesetHash = _.get(this.schemaHash, 'properties.rulesetHash', {})
          this.fieldDefsMap = _.get(this.schemaHash, 'properties.fieldDefsMap', {})
          this.defaultDataObject = _.get(this.schemaHash, 'properties.dataObject', {})
          this.setSchemaOptionsRuleSetMap(Object.values(this.rulesetHash))
          this.updateAllAvailableOptions(this.fieldOptions)
          if (!_.isEmpty(this.dataHash.conditions)) {
            this.prepareDisplayCondition(this.dataHash.conditions)
          }
          this.ensureTrailingEmptyCondition();
          this.normalizeConditionJoins();
        }

        this.isSchemaAvailable = true;
        this.applySchemaConditions();
      } else if (!_.isEmpty(this.schema) && _.hasIn(this.schema, 'properties') && !_.isEmpty(this.schema.properties)) {
        // Fallback for schemas that use sections.fields + flat properties
        this.schemaHash = _.cloneDeep(this.schema);
        this.selectedTabType = 'basic';
        this.isSchemaAvailable = true;
        this.applySchemaConditions();
      } else {
        this.isSchemaAvailable = false;
      }

    } else if (!_.isEmpty(this.schema) && _.hasIn(this.schema, 'properties') && !_.isEmpty(this.schema.properties)) {
      this.schemaHash = _.cloneDeep(this.schema);
      this.isSchemaAvailable = true;
      this.applySchemaConditions();
    } else {
      this.isSchemaAvailable = false;
    }
  }



  currentSectionIndex: number = 0
  isFirstSection(): boolean {
    return this.currentSectionIndex === 0;
  }

  isLastSection(): boolean {
    return this.currentSectionIndex === this.sections.length - 1;
  }

  goToSection(index: number) {
    this.currentSectionIndex = index;
    this.renderSchema(index)
  }

  previousSection() {
    this.currentSectionIndex--;
    this.renderSchema(this.currentSectionIndex);
  }

  nextSection() {
    this.currentSectionIndex++;
    this.renderSchema(this.currentSectionIndex);
  }

  toggleMultiSelect(item: any, event: any) {
    if (event) {
      event.stopPropagation();
    }
    if (!this.readonly) {
      item.isOpen = !item.isOpen;
      this.cdr.detectChanges();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target?.closest?.('.custom-dropdown')) {
      this.openDropdownId = null;
    }

    // Check if click is outside any multiselect container
    const multiselectContainer = target.closest('.daf-multiselect-container');

    // Only close if click is completely outside the multiselect component
    if (!multiselectContainer) {
      if (this.schemaHash && this.schemaHash.properties) {
        Object.keys(this.schemaHash.properties).forEach(key => {
          const property = this.schemaHash.properties[key];
          if (property && property.isOpen) {
            property.isOpen = false;
          }
        });
        this.cdr.detectChanges();
      }
    }
  }

  // Custom dropdown state
  openDropdownId: string | null = null;

  toggleDropdown(dropdownId: string, event?: Event): void {
    event?.stopPropagation();
    this.openDropdownId = this.openDropdownId === dropdownId ? null : dropdownId;
  }

  closeDropdown(): void {
    this.openDropdownId = null;
  }

  isDropdownOpen(dropdownId: string): boolean {
    return this.openDropdownId === dropdownId;
  }

  getDropdownLabel(options: any[], value: any, placeholder: string): string {
    if (value === undefined || value === null || value === '') {
      return placeholder;
    }
    const match = _.find(options, (opt: any) => String(opt.id) === String(value));
    return match?.name || match?.text || placeholder;
  }

  getSchemaDropdownOptions(field: any): any[] {
    const valueField = field?.valueField || 'value';
    const textField = field?.textField || 'label';
    return _.map(field?.options || [], (opt: any) => ({
      id: opt?.[valueField] ?? opt?.value ?? opt?.id ?? opt,
      name: opt?.[textField] ?? opt?.label ?? opt?.text ?? String(opt)
    }));
  }

  getConditionLhsOptions(): any[] {
    return _.map(this.fieldOptions || [], (field: any) => ({
      id: field.unique_id,
      name: field.display_name || field.text
    }));
  }

  getConditionSubLhsOptions(data: any): any[] {
    return _.map(data?.subFieldOptions || [], (field: any) => ({
      id: field.id,
      name: field.text
    }));
  }

  getConditionOperatorOptions(data: any): any[] {
    return _.map(data?.operators || [], (operator: any) => ({
      id: operator._id,
      name: operator.text
    }));
  }

  getConditionValueOptions(data: any): any[] {
    return _.map(data?.posibleValues || [], (valueItem: any) => ({
      id: valueItem.id,
      name: valueItem.text
    }));
  }

  onCustomSelect(dropdownId: string, value: any, handler: string, ...args: any[]): void {
    this.closeDropdown();
    switch (handler) {
      case 'schemaDropdown': {
        const key = args[0];
        const field = args[1];
        if (key !== undefined) {
          this.dataHash[key] = value;
          this.onFormValueChange(field, key, { target: { value } }, value);
        }
        break;
      }
      case 'conditionLhs':
        if (args[0] !== undefined) {
          this.dataHash.conditions[args[0]].unique_id = value;
          this.onFieldSelect(value, args[0]);
        }
        break;
      case 'conditionSubLhs':
        if (args[0] !== undefined && args[1] !== undefined) {
          this.dataHash.conditions[args[0]].field_id_value = value;
          this.getRHSBasedOnSubLHS('subLHS', value, args[1], args[0]);
        }
        break;
      case 'conditionOperator':
        if (args[0] !== undefined) {
          this.dataHash.conditions[args[0]].operator_id = value;
          this.onOperatorChange(value, args[0]);
        }
        break;
      case 'conditionValue':
        if (args[0] !== undefined && args[1] !== undefined) {
          this.dataHash.conditions[args[0]].value = value;
          this.onValueChange(value, args[1], args[0]);
        }
        break;
    }
    this.cdr.detectChanges();
  }


  filterMultiSelectOptions(item: any, searchText: string): any[] {
    if (!item || !item.options || !Array.isArray(item.options)) return [];
    // Always show all options if search text is empty or undefined
    if (!searchText || searchText.trim() === '') {
      return item.options;
    }

    const textField = item.textField || 'text';
    const lowerSearch = searchText.toLowerCase().trim();
    return item.options.filter((opt: any) => {
      const text = opt[textField] || opt.label || opt.text || String(opt);
      return String(text).toLowerCase().includes(lowerSearch);
    });
  }

  getMultiSelectSelectedLabel(selected: any, fieldSchema: any): string {
    if (selected == null) {
      return '';
    }
    if (typeof selected === 'string' || typeof selected === 'number') {
      const match = _.find(fieldSchema?.options || [], (opt: any) =>
        String(opt.id || opt.value) === String(selected));
      return match?.name || match?.text || String(selected);
    }
    const textField = fieldSchema?.textField || 'name';
    return selected[textField] || selected.label || selected.text || selected.name || String(selected.id || '');
  }

  removeMultiSelectOption(item: any, option: any, uniqueIdField: string, event: Event): void {
    event.stopPropagation();
    this.selectMultiSelectOption(item, option, uniqueIdField);
  }

  selectMultiSelectOption(item: any, option: any, uniqueIdField: string): void {
    const key = item.key;
    if (!Array.isArray(this.dataHash[key])) {
      this.dataHash[key] = [];
    }

    const optionId = option[uniqueIdField] || option.id || option.value;

    // Matching old Select All behavior for Applies To Field
    if (optionId === 'all') {
      const fieldSchema = item.value || {};
      const allOptions = (fieldSchema.options || []).filter((opt: any) =>
        (opt[uniqueIdField] || opt.id || opt.value) !== 'all');
      const allSelected = allOptions.length > 0 && allOptions.every((opt: any) =>
        this.isMultiSelectOptionSelected(item, opt, uniqueIdField));
      this.dataHash[key] = allSelected ? [] : [...allOptions];
      this.cdr.detectChanges();
      return;
    }

    const existingIndex = this.dataHash[key].findIndex((sel: any) => {
      const selId = typeof sel === 'string' || typeof sel === 'number'
        ? sel
        : (sel[uniqueIdField] || sel.id || sel.value);
      return selId === optionId;
    });

    if (existingIndex >= 0) {
      this.dataHash[key].splice(existingIndex, 1);
    } else {
      this.dataHash[key].push(option);
    }
    this.cdr.detectChanges();
  }

  isMultiSelectOptionSelected(item: any, option: any, uniqueIdField: string): boolean {
    const key = item.key;
    if (!Array.isArray(this.dataHash[key])) {
      return false;
    }
    const optionId = option[uniqueIdField] || option.id || option.value;
    if (optionId === 'all') {
      const fieldSchema = item.value || {};
      const allOptions = (fieldSchema.options || []).filter((opt: any) =>
        (opt[uniqueIdField] || opt.id || opt.value) !== 'all');
      return allOptions.length > 0 && allOptions.every((opt: any) =>
        this.isMultiSelectOptionSelected(item, opt, uniqueIdField));
    }
    return this.dataHash[key].some((sel: any) => {
      const selId = typeof sel === 'string' || typeof sel === 'number'
        ? sel
        : (sel[uniqueIdField] || sel.id || sel.value);
      return selId === optionId;
    });
  }



  // condition related methods
  schemaOptionsRuleSetMap: any = {};
  optionList: any = {};

  // setSchemaOptionsRuleSetMap is used to set the schema options rule set map
  setSchemaOptionsRuleSetMap(ruleSetList: any) {
    this.schemaOptionsRuleSetMap = {};
    _.each(ruleSetList, (rule: any) => {
      if (_.get(rule, 'schema.options')) {
        this.schemaOptionsRuleSetMap[rule._id] = {};
        _.each(rule.schema.options, (value: any, key: any) => {
          this.schemaOptionsRuleSetMap[rule.id][key] = value.unique_id;
        });
      }
    });
  }


  // updateAllAvailableOptions is used to update the option list
  updateAllAvailableOptions(rulesetList) {
    this.optionList = {};
    _.each(rulesetList, (rule: any) => {
      var options = _.get(rule, "schema.options");
      if (!_.isEmpty(options)) {
        Object.assign(this.optionList, options);
      }
    });
  }


  // prepareDisplayCondition is used to prepare the display condition
  prepareDisplayCondition(conditions: any) {
    _.each(conditions, (condition, index) => {
      var ruleSetId = condition["ruleset_id"];
      var ruleDetail = this.rulesetHash[ruleSetId];

      condition["operatorDetail"] = this.getOperatorById(condition["operator_id"]);

      _.each(this.schemaOptionsRuleSetMap, (rulesets: any) => {
        _.each(rulesets, (field_value: any, fieldKey: any): any => {
          if (field_value == condition["unique_id"]) {
            const selectedLHS: any = _.find(this.fieldOptions, (field: any) => field.unique_id == field_value)
            var promiseForRhs: any = this.checkForPredefinedField(selectedLHS, 'rhs', fieldKey, condition["value"]);
            promiseForRhs.then((value: any) => {
              condition["rhs"] = value;
            });
            this.setOperatorBasedOnLHS(selectedLHS, index);
            if (condition["field_id_value"]) {
              this.getRHSBasedOnSubLHS(selectedLHS["value_type"], { target: { value: condition["field_id_value"] } }, selectedLHS["unique_id"], index);
            }
            var lhsDisplayName = _.get(ruleDetail, "schema.options." + fieldKey + ".display_name");
            var promiseForLhs: any = this.checkForPredefinedField(selectedLHS, 'lhs', fieldKey, lhsDisplayName, condition["field_id_value"]);
            promiseForLhs.then((value: any) => {
              condition["lhs"] = value;
            });
            return false;
          }
        })
      })
    });
  }

  // checkForPredefinedField is used to check the predefined field
  checkForPredefinedField(selectedLHS: any, type: string, fieldId: string, value: any, fieldIdValue?: any): any {
    var response = '';
    var params: any = {};
    // workflowConditionsVM.optionList contains all the options available all over the brands including the expression
    var selectedOption: any = {};

    if (this.optionList[fieldId]) {
      selectedOption = this.optionList[fieldId];
    } else {
      selectedOption = selectedLHS;
    }
    var valueToSet = fieldIdValue != null ? fieldIdValue : value;
    // var fieldIdStr = "[field_id==" + valueToSet + "]";
    var fieldIdStr = "[field_id==" + valueToSet + "]";
    // var fieldIdToCheck = Utils.getProp(selectedOption, "options.field_id");
    // var fieldIdToCheck = Utils.getProp(selectedOption, "options.field_id");
    var fieldIdToCheck;
    if (selectedOption) {
      // fieldIdStr = "[" + (fieldIdToCheck || "field_id") + "==" + valueToSet + "]";
      fieldIdStr = "[" + (fieldIdToCheck || "field_id") + "==" + valueToSet + "]";
      if (type == 'rhs') {
        // In case of RHS if 'expression' is present then resolve it to get the RHS else return the same value.
        if (selectedOption["value_type"] == "string" || selectedOption["value_type"] == "number") {
          params = {};
        } else if (selectedOption["expression"]) {
          // Now pass the expression to get the prefilled value
          params = {
            "type": 3,
            "expression": selectedOption["expression"]
          }
        }
      } else if (type == 'lhs') {
        if (selectedOption["target_field"]) {
          var expBasedOnSubLHS = selectedOption["target_field"];

          // Now, get the last index of '}}'(end of expression)
          var expEndInx = expBasedOnSubLHS.lastIndexOf("}}");

          // Append the condition to filter based on selected LHS
          if (expEndInx > -1)
            expBasedOnSubLHS = expBasedOnSubLHS.substr(0, expEndInx) + fieldIdStr + expBasedOnSubLHS.substr(expEndInx);

          params = {
            "type": 3,
            "expression": expBasedOnSubLHS
          }
        }
      }


      if (_.isEmpty(params)) {
        return new Promise((resolve, reject) => {
          if (type == 'rhs' && selectedOption && !(_.isEmpty(selectedOption.possible_values)) && _.isArray(selectedOption.possible_values)) {
            value = _.findWhere(selectedOption.possible_values, { "id": value }) || {}
            resolve(value.text || value);
          } else {
            resolve(value);
          }
        })

      } else {
        return new Promise((resolve, reject) => {
          this._workflowDatasource.getData(params, (error: any, response: any) => {
            if (error) {
              reject('Oops... something went wrong');
            } else {
              var displayField = response["displayField"];
              var fieldToDisplay = _.filter(Helpers.deepClone(response["data"]), function (field) {
                return fieldIdToCheck ? (field[fieldIdToCheck] == value) : (field.uuid == value || field._id == value);
              });
              if (fieldToDisplay && fieldToDisplay.length) {
                response = fieldToDisplay[0][displayField];
              } else {
                response = _.get(response, "data.0." + displayField);
              }
              resolve(response);
            }
          });
        });
      }
    }
  }

  onJoinOperatorChange(joinId: string, index: number) {
    // Join between condition[index-1] and condition[index] is stored on n-1
    if (!this.dataHash?.conditions || index <= 0) {
      return;
    }
    const previousIndex = index - 1;
    if (this.dataHash.conditions[previousIndex]) {
      this.dataHash.conditions[previousIndex].join_id = joinId;
    }
    this.cdr.detectChanges();
  }

  /** True when condition has no LHS / operator / value filled */
  isConditionEmpty(condition: any): boolean {
    if (!condition) {
      return true;
    }
    const noField = !condition.unique_id && !condition.field_id;
    const noOperator = !condition.operator_id;
    const noValue = condition.value === undefined || condition.value === null || condition.value === '';
    return noField && noOperator && noValue;
  }

  /** True when some (but not all) required fields are filled */
  isConditionPartial(condition: any): boolean {
    if (!condition || this.isConditionEmpty(condition)) {
      return false;
    }
    return !this.isConditionComplete(condition);
  }

  isConditionComplete(condition: any): boolean {
    if (!condition) {
      return false;
    }
    if (!condition.unique_id || condition.unique_id === '' ||
      !condition.operator_id || condition.operator_id === '' ||
      condition.value === undefined || condition.value === null || condition.value === '') {
      return false;
    }
    if (condition.isSubLHSEnabled) {
      return !!(condition.field_id_value && condition.field_id_value !== '');
    }
    return true;
  }

  /**
   * Join lives on n-1. If last row is blank, clear join on length-2.
   * Last complete condition always has join_id = null.
   */
  normalizeConditionJoins(): void {
    const conditions = this.dataHash?.conditions;
    if (!conditions || !conditions.length) {
      return;
    }

    const lastIndex = conditions.length - 1;
    const lastIsEmpty = this.isConditionEmpty(conditions[lastIndex]);

    // If trailing blank row exists, remove join on length-2 (no next real condition)
    if (lastIsEmpty && conditions.length >= 2) {
      conditions[conditions.length - 2].join_id = null;
    }

    // Ensure last complete condition has null join; keep joins only between complete pairs
    for (let i = 0; i < conditions.length; i++) {
      const current = conditions[i];
      const next = conditions[i + 1];
      if (!this.isConditionComplete(current)) {
        continue;
      }
      if (!next || this.isConditionEmpty(next) || !this.isConditionComplete(next)) {
        current.join_id = null;
      } else if (!current.join_id) {
        current.join_id = '$or';
      }
    }
  }

  /** Disable Save when any condition is partially filled */
  hasPartialConditions(): boolean {
    const conditions = this.dataHash?.conditions;
    if (!conditions || !conditions.length) {
      return false;
    }
    return _.some(conditions, (c: any) => this.isConditionPartial(c));
  }

  /** Show AND/OR before condition[i] when index > 0 (join stored on n-1) */
  shouldShowJoinOperator(index: number): boolean {
    const conditions = this.dataHash?.conditions;
    if (!conditions || conditions.length <= 1) {
      return false;
    }
    return index > 0;
  }

  getJoinOperatorForIndex(index: number): string {
    const conditions = this.dataHash?.conditions;
    if (!conditions || index <= 0) {
      return '$or';
    }
    // Join between i-1 and i is stored on conditions[i-1]
    return conditions[index - 1]?.join_id === '$and' ? '$and' : '$or';
  }

  isEditingExistCondition(condition: any, index: number): boolean {
    const conditions = this.dataHash?.conditions;
    if (!conditions || !conditions.length) {
      return false;
    }
    return (conditions.length - 1) !== index && condition.editing;
  }

  onFieldSelect(eventOrValue: any, index: number) {
    const uniqueId = eventOrValue?.target?.value !== undefined ? eventOrValue.target.value : eventOrValue;
    const selectedLHS: any = _.find(this.fieldOptions, (field: any) => field.unique_id == uniqueId);
    this.setOperatorBasedOnLHS(selectedLHS, index);
    this.normalizeConditionJoins();
    this.cdr.detectChanges();
  }

  onOperatorChange(eventOrValue: any, index: number) {
    const operatorId = eventOrValue?.target?.value !== undefined ? eventOrValue.target.value : eventOrValue;
    const selectedOperator: any = this.getOperatorById(operatorId);
    this.dataHash.conditions[index].operatorDetail = selectedOperator;
    this.normalizeConditionJoins();
    this.cdr.detectChanges();
  }

  onValueChange(eventOrValue: any, data: any, index: number) {
    const value = eventOrValue?.target?.value !== undefined ? eventOrValue.target.value : eventOrValue;
    const selectedValue: any = _.find(data.posibleValues, (valueItem: any) => valueItem.id == value);
    if (selectedValue && data["rhsHasPossibleValue"]) {
      this.dataHash.conditions[index].rhs = selectedValue.text || selectedValue.id;
    } else {
      this.dataHash.conditions[index].rhs = value;
    }
    this.normalizeConditionJoins();
    this.cdr.detectChanges();
  }

  getOperatorById(id: string) {
    switch (id) {
      case "$eq":
        return {
          "text": "Equals",
          "symbol": "=="
        };
      case "$has":
        return {
          "text": "Contains",
          "symbol": "=="
        };
      case "$lt":
        return {
          "text": "Less than",
          "symbol": "<"
        };
      case "$gt":
        return {
          "text": "Greater than",
          "symbol": ">"
        };
      case "$lte":
        return {
          "text": "Less than equals",
          "symbol": "<="
        };
      case "$gte":
        return {
          "text": "Greater than equals",
          "symbol": ">="
        };
      case "$ne":
        return {
          "text": "Not Equals",
          "symbol": "!="
        };
      default:
        return null;
    }
  }

  getOperatorsBasedOnType(selectedRuleset: any, type: string) {
    var availableOperator = _.get(selectedRuleset, "schema.operators." + type);
    if (!availableOperator) {
      // Get the all available operators for string, text, number.
      // This will return the key-value pair, where key will be string, text, number.
      var operatorsList = _.get(selectedRuleset, "schema.operators");
      if (operatorsList) {
        // Now fetch only the values(from the key-value pair) and flatten all the values.
        // This will return the available operators.
        operatorsList = _.flatten(Object.values(operatorsList));

        // filter out duplicate operator
        var operatorMap = {};
        availableOperator = _.filter(operatorsList, (operator: any) => {
          if (operatorMap[operator["_id"]]) {
            // If the operatorMap contains the operator's id.
            return false;
          } else {
            // If map doesn't contains the operator's id.
            operatorMap[operator["_id"]] = true;
            return true;
          }
        });
      }
    }
    availableOperator = _.map(availableOperator, (opDetail: any) => {
      opDetail["id"] = opDetail["_id"];
      return opDetail;
    });
    return availableOperator;
  }

  setOperatorBasedOnLHS(selectedLHS: any, index: number, valueType?: string) {
    this.dataHash.conditions[index].isSubLHSEnabled = false;
    this.dataHash.conditions[index].rhsHasPossibleValue = false;
    this.dataHash.conditions[index].field_id = selectedLHS['ruleset_key'];
    this.dataHash.conditions[index].ruleset_id = selectedLHS['ruleset_id'];
    this.dataHash.conditions[index].lhs = selectedLHS['display_name'] || selectedLHS['text'] || selectedLHS['id'];
    if (this.dataHash.conditions[index].field_id_value) {
      const selectedSubLHS: any = _.find(this.dataHash.conditions[index].subFieldOptions, (field: any) => field.unique_id == this.dataHash.conditions[index].field_id_value);
      this.dataHash.conditions[index].lhs = selectedSubLHS['display_name'] || selectedSubLHS['text'] || selectedSubLHS['id'];
    }
    // Get the type of selected LHS
    var type = selectedLHS['value_type']
    const rulesetIdArr: any = selectedLHS.unique_id.split("___")
    const rulesetId: string = (rulesetIdArr && rulesetIdArr.length) ? rulesetIdArr[0] : '';
    // const field = _.find(this.fieldOptions, (field: any) => field.unique_id == selectedLHS.unique_id)

    let selectedRuleset = _.get(this.rulesetHash, rulesetId, {})

    if (valueType) {
      type = valueType;
    }
    this.dataHash.conditions[index].value_type = type;
    var availableOperator = _.get(selectedRuleset, "schema.operators." + type);
    if (!availableOperator) {
      // Get the all available operators for string, text, number.
      // This will return the key-value pair, where key will be string, text, number.
      var operatorsList = _.get(selectedRuleset, "schema.operators");
      if (operatorsList) {
        // Now fetch only the values(from the key-value pair) and flatten all the values.
        // This will return the available operators.
        operatorsList = _.flatten(Object.values(operatorsList));

        // filter out duplicate operator
        var operatorMap = {};
        availableOperator = _.filter(operatorsList, (operator: any) => {
          if (operatorMap[operator["_id"]]) {
            // If the operatorMap contains the operator's id.
            return false;
          } else {
            // If map doesn't contains the operator's id.
            operatorMap[operator["_id"]] = true;
            return true;
          }
        });
      }
    }
    availableOperator = _.map(availableOperator, (opDetail: any) => {
      opDetail["id"] = opDetail["_id"];
      return opDetail;
    });
    if (valueType) {
      this.dataHash.conditions[index].isSubLHSEnabled = true;
      this.dataHash.conditions[index].operators = availableOperator;
    } else {
      this.prepareOperatorsAndRHSBasedOnLHS(index, selectedLHS, availableOperator);
    }

  }

  prepareOperatorsAndRHSBasedOnLHS(index, selectedLHS, operators) {

    if (selectedLHS["expression"]) {
      // In case the selected LHS contains expression then set rhsHasPossibleValue as true.
      this.dataHash.conditions[index].rhsHasPossibleValue = true;
      // resolve the expression to get one more LHS options
      this._workflowDatasource.getData({
        "type": 3,
        "expression": selectedLHS["expression"]
      }, (error: any, response: any) => {
        if (!error) {
          var displayField = response["displayField"];
          var idField = _.get(selectedLHS, "options.field_id");
          var data = _.map(response["data"], function (d) {
            return {
              "id": d["uuid"] || d["field_id"] || d[idField],
              "text": d[displayField],
              "group_id": d['group_id'] || null,
              "is_group": (d.custom_parameter_type == 4 && !d.group_id) ? true : false,
              "data_type": d.data_type,
              "is_custom_field": d.custom_parameter_type == 4
            };
          });
          if (selectedLHS["value_type"] == "expression") {
            this.dataHash.conditions[index].isSubLHSEnabled = false;
            this.dataHash.conditions[index].posibleValues = data;
          } else {
            this.dataHash.conditions[index].isSubLHSEnabled = true;
            this.dataHash.conditions[index].subFieldOptions = data;
          }
          this.dataHash.conditions[index].operators = operators;
        }
      });
    } else if (selectedLHS && !(_.isEmpty(selectedLHS.possible_values)) && _.isArray(selectedLHS.possible_values)) {
      this.dataHash.conditions[index].rhsHasPossibleValue = true;
      var data = selectedLHS.possible_values;
      this.dataHash.conditions[index].posibleValues = data;
    }
    this.dataHash.conditions[index].operators = operators;
  }

  getRHSBasedOnSubLHS(type: string, eventOrValue: any, uniqueId: string, index: number) {
    const selectedOption = eventOrValue?.target?.value !== undefined ? eventOrValue.target.value : eventOrValue;
    const selectedLHS: any = _.find(this.fieldOptions, (field: any) => field.unique_id == uniqueId);

    if (selectedOption) {
      const selectedSubLHS: any = _.find(this.dataHash.conditions[index].subFieldOptions, (field: any) => field.id == selectedOption);
      if (selectedSubLHS) {
        this.dataHash.conditions[index].lhs = selectedSubLHS.text || selectedSubLHS.id;
      } else {
        this.dataHash.conditions[index].lhs = selectedLHS.display_name || selectedLHS.text || selectedLHS.id;
      }
      // If 'value_type' contains any expression then the RHS needs to be populated by resolving the expression
      if (selectedLHS) {
        if (selectedLHS["possible_values"]) {
          this.dataHash.conditions[index].rhsHasPossibleValue = true;
          var expBasedOnSubLHS = selectedLHS["possible_values"];

          // Now, get the last index of '}}'(end of expression)
          var expEndInx = expBasedOnSubLHS.lastIndexOf("}}");

          // Append the condition to filter based on selected LHS
          if (expEndInx > -1)
            expBasedOnSubLHS = expBasedOnSubLHS.substr(0, expEndInx) + "[field_id==" + selectedOption + "]" + expBasedOnSubLHS.substr(expEndInx);
          // Resolved the expression to get the possible values
          this._workflowDatasource.getData({
            "type": 3,
            "expression": expBasedOnSubLHS
          }, (error: any, response: any) => {
            if (!error) {
              var options = _.get(response, "data.0." + response["displayField"]);
              options = _.map(options, (d: any) => {
                let data: any = {}
                if (typeof d == 'object') {
                  data = d
                  data.id = d["text"]

                } else {
                  data.id = d
                  data.text = d
                }
                return data;
              });
              this.dataHash.conditions[index].posibleValues = options;
            }
          });
        } else {
          this.dataHash.conditions[index].rhsHasPossibleValue = false;
        }
      } else {
        this.dataHash.conditions[index].rhsHasPossibleValue = false;
      }

      if (this.fieldDefsMap[selectedOption] && this.fieldDefsMap[selectedOption]['data_type']) {
        this.setOperatorBasedOnLHS(selectedOption, this.fieldDefsMap[selectedOption]['data_type']);
      }
    }
  }




  validateCondition(index: number): boolean {
    return this.isConditionComplete(this.dataHash.conditions[index]);
  }

  addRule(index: number): void {
    if (!this.dataHash?.conditions || !this.dataHash.conditions[index]) {
      return;
    }

    if (!this.validateCondition(index)) {
      if (Helpers && Helpers.smallAlertBox) {
        Helpers.smallAlertBox('Error', 'Please fill all condition fields before adding.', 'error', 3000);
      }
      return;
    }

    const conditions = this.dataHash.conditions;
    const isLastRow = index === conditions.length - 1;

    // Finalize current row
    conditions[index].editing = false;

    // Ensure field_id from unique_id when missing
    if (conditions[index].unique_id && !conditions[index].field_id) {
      conditions[index].field_id = String(conditions[index].unique_id).split('___')[1] || conditions[index].unique_id;
    }

    if (isLastRow) {
      // Adding a new condition from trailing editor:
      // join for this row lives on n-1 (previous). Current becomes second-last once empty is pushed,
      // so set join on previous complete neighbor via normalize; current gets join only if another
      // complete follows — trailing empty means current.join_id must be null after normalize.
      conditions[index].join_id = null;

      // Keep a single empty editing row at the end for next add
      const alreadyHasEmptyTrail = conditions.length > 1 && this.isConditionEmpty(conditions[conditions.length - 1]) && index < conditions.length - 1;
      if (!alreadyHasEmptyTrail) {
        const newCondition = _.cloneDeep(this.defaultDataObject || {});
        newCondition.editing = true;
        newCondition.join_id = null;
        conditions.push(newCondition);
      }
    } else {
      // Updating an existing mid-list condition — keep its join to next if next is complete
      const next = conditions[index + 1];
      if (!next || this.isConditionEmpty(next) || !this.isConditionComplete(next)) {
        conditions[index].join_id = null;
      } else if (!conditions[index].join_id) {
        conditions[index].join_id = '$or';
      }
    }

    // If previous exists and current is complete, ensure previous has a join (n-1 pattern)
    if (index > 0 && this.isConditionComplete(conditions[index - 1]) && this.isConditionComplete(conditions[index])) {
      if (!conditions[index - 1].join_id) {
        conditions[index - 1].join_id = '$or';
      }
    }

    this.normalizeConditionJoins();
    this.ensureTrailingEmptyCondition();
    this.cdr.detectChanges();
  }

  /** Ensure exactly one trailing empty editing row for adding */
  ensureTrailingEmptyCondition(): void {
    if (!this.dataHash.conditions) {
      this.dataHash.conditions = [];
    }
    const conditions = this.dataHash.conditions;
    if (!conditions.length) {
      const empty = _.cloneDeep(this.defaultDataObject || {});
      empty.editing = true;
      empty.join_id = null;
      conditions.push(empty);
      return;
    }

    const last = conditions[conditions.length - 1];
    if (last && !last.editing && !this.isConditionEmpty(last)) {
      // Last is filled — append empty editor row
      const empty = _.cloneDeep(this.defaultDataObject || {});
      empty.editing = true;
      empty.join_id = null;
      conditions.push(empty);
    } else {
      last.editing = true;
      last.join_id = null;
    }

    // Only one empty trailing row
    while (conditions.length > 1 &&
      this.isConditionEmpty(conditions[conditions.length - 1]) &&
      this.isConditionEmpty(conditions[conditions.length - 2])) {
      conditions.pop();
    }

    this.normalizeConditionJoins();
  }

  editRule(index: number): void {
    if (!this.dataHash?.conditions?.[index]) {
      return;
    }
    // Close other editors except trailing empty row
    _.each(this.dataHash.conditions, (c: any, i: number) => {
      if (i === index) {
        return;
      }
      if (!this.isConditionEmpty(c)) {
        c.editing = false;
      }
    });
    this.dataHash.conditions[index].editing = true;
    this.ensureTrailingEmptyCondition();
    this.normalizeConditionJoins();
    this.cdr.detectChanges();
  }

  deleteRule(index: number): void {
    if (!this.dataHash?.conditions) {
      return;
    }
    this.dataHash.conditions.splice(index, 1);
    this.ensureTrailingEmptyCondition();
    this.normalizeConditionJoins();
    this.cdr.detectChanges();
  }

  clearCondition(index: number): void {
    if (!this.dataHash?.conditions || !this.dataHash.conditions[index]) {
      return;
    }
    const empty = _.cloneDeep(this.defaultDataObject || {});
    empty.editing = true;
    empty.join_id = null;
    this.dataHash.conditions[index] = empty;

    // If cleared mid-list row, remove it and keep trailing empty
    if (index !== this.dataHash.conditions.length - 1) {
      this.dataHash.conditions.splice(index, 1);
    }
    this.ensureTrailingEmptyCondition();
    this.normalizeConditionJoins();
    this.cdr.detectChanges();
  }

  onFormValueChange(property: any, key: string, event: any, value: any) {
    this.applySchemaConditions(key);

    // Matching old basic-config: changing Event resets conditions / conditions_v2
    if (key === 'event_name') {
      this.handleEventChange(value);
    }

    this.isValidValue(value, property, key);
    this.cdr.detectChanges();
  }

  /**
   * Apply show/hide (and related) conditions across all schema sections + current schemaHash
   */
  applySchemaConditions(changedKey?: string) {
    const applyToProps = (properties: any) => {
      if (!properties) {
        return;
      }
      _.each(properties, (field: any) => {
        if (field && field.condition) {
          const parentKey = field.condition.parentField;
          const shouldApply = !changedKey ||
            parentKey === changedKey ||
            // Rule type change must re-evaluate Applies To Field (has_child)
            (changedKey === 'type' && field.condition.operator === 'has_child');
          if (shouldApply) {
            this.updateFieldBasedOnCondition(field, field.condition, parentKey);
          }
        }
      });
    };

    if (this.schema) {
      _.each(['basic', 'advanced', 'conditions'], (sectionKey: string) => {
        applyToProps(_.get(this.schema, sectionKey + '.properties'));
      });
      applyToProps(this.schema.properties);
    }
    applyToProps(_.get(this.schemaHash, 'properties'));
  }

  /**
   * Matching old select2:select on event — reset conditions_v2 group and flat conditions
   */
  private handleEventChange(newEventId: any): void {
    if (!newEventId || newEventId === this.previousEventName) {
      return;
    }

    const hadPreviousEvent = !!this.previousEventName;
    this.previousEventName = newEventId;
    this.dataHash.event_id_list = [newEventId];

    // Only reset when user actually changes an already-selected event
    if (!hadPreviousEvent) {
      if (this.conditionsV2Enabled && !this.dataHash.conditions_v2) {
        this.dataHash.conditions_v2 = {
          logical_operator: 'AND',
          uuid: this.generateGuid(),
          rules: []
        };
      }
      return;
    }

    this.dataHash.conditions_v2 = {
      logical_operator: 'AND',
      uuid: this.generateGuid(),
      rules: []
    };

    const emptyCondition = _.cloneDeep(this.defaultDataObject || {});
    emptyCondition.editing = true;
    if (this.dataHash.conditions && this.dataHash.conditions.length > 0) {
      const lastCondition = this.dataHash?.conditions[this.dataHash.conditions.length - 1];
      if (!(lastCondition && lastCondition.editing && this.isConditionEmpty(lastCondition))) {
        this.dataHash.conditions.push(emptyCondition);
      }
    } else {
      this.dataHash.conditions = [emptyCondition];
    }


    if (Helpers && Helpers.smallAlertBox && this.conditionsV2Enabled) {
      Helpers.smallAlertBox('Info', 'Conditions have been reset because the Event was changed.', 'info', 3000);
    }
  }

  private generateGuid(): string {
    if (Helpers && Helpers.guid) {
      return Helpers.guid();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  updateFieldBasedOnCondition(field: any, condition: any, key: string) {
    if (condition.parentField && condition.parentField == key) {
      if (_.has(condition, 'operator') && condition.operator != '') {
        const cacheKey = "original_value_" + condition.fieldToUpdate;
        if (!_.has(field, cacheKey)) {
          field[cacheKey] = field[condition.fieldToUpdate];
        }
        const matches = this.evaluateConditionMatch(condition, key);

        // Applies To Field: show/hide + populate child options from selected parent
        if (condition.operator === 'has_child') {
          this.applyHasChildFieldOptions(field, condition, key, matches);
          return field;
        }

        if (condition.operator === 'any' || condition.operator === 'all' ||
          condition.operator === 'eq' || condition.operator === 'neq' ||
          condition.operator === 'in' || condition.operator === 'not_in' ||
          condition.operator === 'starts_with') {
          if (matches) {
            field[condition.fieldToUpdate] = condition.valueToSet;
          } else {
            field[condition.fieldToUpdate] = field[cacheKey];
          }
        }
      } else if (condition.fieldToUpdate == 'options') {
        if (_.has(this.dataHash, key) && this.dataHash[key] != '' && !_.isEmpty(field.optionsMap) && _.has(field.optionsMap, this.dataHash[key])) {
          // Clone so child options metadata stays intact per field instance
          field[condition.fieldToUpdate] = _.cloneDeep(field.optionsMap[this.dataHash[key]]);
        } else {
          field[condition.fieldToUpdate] = [];
        }
      }
    }
    return field;
  }

  private previousAppliesToValue: any = null;

  /**
   * Matching old applies-to-changed: when parent group has children and rule is not mandatory,
   * show Applies To Field multi-select and load child options (+ Select All).
   */
  private applyHasChildFieldOptions(field: any, condition: any, parentKey: string, matches: boolean) {
    const cacheKey = 'original_value_' + condition.fieldToUpdate;
    const ruleType = this.dataHash?.type;
    const showChildField = matches && ruleType !== 'mandatory';
    const childKey = this.getFieldKeyFromSchema(field) || 'applies_to_child_field_ids';
    const parentValue = this.dataHash[parentKey];
    const parentChanged = parentKey === 'applies_to' &&
      this.previousAppliesToValue !== undefined &&
      this.previousAppliesToValue !== parentValue;

    if (showChildField) {
      field[condition.fieldToUpdate] = condition.valueToSet;
      field.required = true;
      field.errorMsg = field.errorMsg || 'Applies to field is mandatory.';
      field.showLabel = true;
      field.hidden = false;

      const childOptions = this.getChildOptionsFromParent(parentKey);
      field.options = childOptions;

      if (!_.has(this.dataHash, childKey) || !Array.isArray(this.dataHash[childKey]) || parentChanged) {
        this.dataHash[childKey] = [];
      }
      this.normalizeMultiSelectSelection(childKey, childOptions);
    } else {
      field[condition.fieldToUpdate] = _.has(field, cacheKey) ? field[cacheKey] : true;
      field.required = false;
      field.hidden = true;
      field.options = [];
      if (_.has(this.dataHash, childKey)) {
        this.dataHash[childKey] = [];
      }
    }

    if (parentKey === 'applies_to') {
      this.previousAppliesToValue = parentValue;
    }
  }

  /** Resolve which schema property key owns this field object */
  private getFieldKeyFromSchema(field: any): string | null {
    const props = _.get(this.schemaHash, 'properties') || {};
    for (const key of Object.keys(props)) {
      if (props[key] === field) {
        return key;
      }
    }
    const basicProps = _.get(this.schema, 'basic.properties') || {};
    for (const key of Object.keys(basicProps)) {
      if (basicProps[key] === field) {
        return key;
      }
    }
    return null;
  }

  /**
   * Build child multi-select options from selected Applies To parent option.children
   * Matching old getAppliesToChildOptions + Select All
   */
  private getChildOptionsFromParent(parentKey: string): any[] {
    const parentValue = this.dataHash[parentKey];
    if (!parentValue) {
      return [];
    }

    const parentField = _.get(this.schemaHash, 'properties.' + parentKey) ||
      _.get(this.schema, 'basic.properties.' + parentKey);
    if (!parentField || !parentField.options) {
      return [];
    }

    const valueField = parentField.valueField || 'id';
    const selectedOption = _.find(parentField.options, (option: any) =>
      (option[valueField] || option.value || option.id) == parentValue);

    if (!selectedOption || !selectedOption.children || !selectedOption.children.length) {
      return [];
    }

    const children = selectedOption.children.map((child: any) => ({
      id: child.id || child[valueField] || child.value,
      name: child.name || child.text || child.label,
      text: child.text || child.name || child.label
    }));

    return [
      { id: 'all', name: 'Select All', text: 'Select All' },
      ...children
    ];
  }

  /** Convert id[] selections to option objects against current options */
  private normalizeMultiSelectSelection(key: string, options: any[]) {
    if (!_.has(this.dataHash, key)) {
      this.dataHash[key] = [];
      return;
    }
    let selected = this.dataHash[key];
    if (!Array.isArray(selected)) {
      selected = selected ? [selected] : [];
    }
    const optionById = _.keyBy(options.filter((o: any) => o.id !== 'all'), 'id');
    this.dataHash[key] = selected
      .map((sel: any) => {
        const id = typeof sel === 'string' || typeof sel === 'number' ? sel : (sel?.id || sel?.value);
        if (id === 'all') {
          return null;
        }
        return optionById[id] || (typeof sel === 'object' ? sel : null);
      })
      .filter(Boolean);
  }

  private evaluateConditionMatch(condition: any, key: string): boolean {
    const currentValue = this.dataHash[key];
    switch (condition.operator) {
      case 'eq':
        return condition.value == currentValue;
      case 'neq':
        return condition.value != currentValue;
      case 'in':
        return _.includes(condition.value || [], currentValue);
      case 'not_in':
        return !_.includes(condition.value || [], currentValue);
      case 'starts_with':
        return String(currentValue || '').indexOf(condition.value) === 0;
      case 'any':
        return _.some(condition.rules || [], (rule: any) =>
          this.evaluateConditionMatch({ ...rule, parentField: condition.parentField }, key));
      case 'all':
        return _.every(condition.rules || [], (rule: any) =>
          this.evaluateConditionMatch({ ...rule, parentField: condition.parentField }, key));
      case 'has_child': {
        const parentField = _.get(this.schemaHash, 'properties.' + condition.parentField) ||
          _.get(this.schema, 'basic.properties.' + condition.parentField);
        if (parentField && parentField.options && parentField.options.length > 0) {
          const selectedOption = _.find(parentField.options, (option: any) =>
            (option[parentField.valueField] || option.value || option.id) == currentValue);
          return !!(selectedOption && selectedOption.children && selectedOption.children.length > 0);
        }
        return false;
      }
      default:
        return false;
    }
  }



  formErrors: any = {};
  validateForm() {
    this.formErrors = {};
    this.applySchemaConditions();
    if (this.sections && this.sections.length > 1) {
      _.each(this.sections, (section: any) => {
        const sectionSchema = section.type ? this.schema[section.type] : null;
        if (sectionSchema) {
          this.validateFormBasedOnSchema(section.type, sectionSchema);
        }
      });
    } else {
      this.validateFormBasedOnSchema('basic', _.cloneDeep(this.schema));
    }
  }

  validateFormBasedOnSchema(type: string, schema: any) {
    if (type == 'basic' || type == 'advanced') {
      const properties = schema?.properties || {};
      _.each(properties, (property: any, key: string) => {
        if (property && property.hidden === true) {
          return;
        }
        this.isValidValue(this.dataHash[key], property, key);
      });
    }
  }

  isValidValue(value: any, property: any, key: string) {
    if (!property || property.hidden === true) {
      return true;
    }
    switch (property.type) {
      case 'string':
        return this.validateString(value, property, key);
      case 'number':
        return this.validateNumber(value, property, key);
      case 'list':
        return this.validateList(value, property, key);
      default:
        return true;
    }
  }

  validateString(value: string, property: any, key: string): boolean {
    if (property.required && !value) {
      this.formErrors[key] = property.errorMessages?.required || property.errorMsg || 'This field is required';
      return false;
    }
    if (property.regex) {
      const regex = new RegExp(property.regex);
      if (!regex.test(value)) {
        this.formErrors[key] = property.errorMessages?.regex || 'Invalid value';
        return false;
      }
    }
    delete this.formErrors[key];
    return true;
  }

  validateList(value: any, property: any, key: string): boolean {
    if (property.required && (!value || value.length == 0)) {
      this.formErrors[key] = property.errorMessages?.required || 'This field is required';
      return false;
    }
    delete this.formErrors[key];
    return true;
  }

  validateNumber(value: number, property: any, key: string): boolean {
    if (property.required && !value) {
      this.formErrors[key] = property.errorMessages?.required || 'This field is required';
      return false;
    }
    if (property.minimum) {
      if (value < property.minimum) {
        this.formErrors[key] = property.errorMessages?.minimum || 'Value must be greater than or equal to ' + property.minimum;
        return false;
      }

    }

    if (property.maximum) {
      if (value > property.maximum) {
        this.formErrors[key] = property.errorMessages?.maximum || 'Value must be less than or equal to ' + property.maximum;
        return false;
      }
    }
    delete this.formErrors[key];
    return true;
  }


  submitForm() {
    if(this.readonly){
      Helpers.smallAlertBox('Access denied',"You do not have write permission","info",1500)
      return
    }
    this.validateForm();
    if (!_.isEmpty(this.formErrors)) {
      Helpers.smallAlertBox("Error", "Please fill all the required fields", "error", 3500);
      return;
    }
    if (this.hasPartialConditions()) {
      Helpers.smallAlertBox("Error", "Please complete or clear partially filled conditions.", "error", 3500);
      return;
    }
    if (_.hasIn(this.dataHash, 'conditions') && this.dataHash.conditions.length > 0) {
      this.normalizeConditionJoins();
      this.dataHash.conditions = this.processConditions(this.dataHash.conditions);
    }
    // Ensure event_id_list is set from event_name (old basic-config)
    if (this.dataHash.event_name && (!this.dataHash.event_id_list || !this.dataHash.event_id_list.length)) {
      this.dataHash.event_id_list = [this.dataHash.event_name];
    }
    this.submit.emit(this.dataHash);
  }





  processConditions(conditions: any[]) {
    let conditionsArray: any[] = [];
    _.each(conditions, (condition: any) => {
      // Skip empty trailing / blank rows and incomplete rows
      if (this.isConditionEmpty(condition) || this.isConditionPartial(condition)) {
        return;
      }
      if (!this.isConditionComplete(condition)) {
        return;
      }
      const cleaned = _.cloneDeep(condition);
      delete cleaned["rhsHasPossibleValue"];
      delete cleaned["isSubLHSEnabled"];
      delete cleaned["posibleValues"];
      delete cleaned["subFieldOptions"];
      delete cleaned["operators"];
      delete cleaned["editing"];
      delete cleaned["lhs"];
      delete cleaned["rhs"];
      delete cleaned["operatorDetail"];
      conditionsArray.push(this.setConditionDataType(cleaned));
    });

    // Last saved condition must have join_id null (n-1 join pattern)
    if (conditionsArray.length) {
      conditionsArray[conditionsArray.length - 1].join_id = null;
    }
    // Ensure joins only between consecutive saved conditions
    for (let i = 0; i < conditionsArray.length - 1; i++) {
      if (!conditionsArray[i].join_id) {
        conditionsArray[i].join_id = '$or';
      }
    }
    return conditionsArray;
  }

  /** Matching old conditions-config setDataType */
  private setConditionDataType(field: any): any {
    if ((field.value_type === 'number' || field.value_type === 'date') && !(isNaN(field.value))) {
      field.value = parseInt(field.value, 10);
    }
    if (this.fieldDefsMap && field.field_id === 'response_has_tag_data' && field.field_id_value) {
      const dataType = this.fieldDefsMap[field.field_id_value]?.data_type;
      field.value_type = (dataType && dataType !== 'list') ? dataType : 'string';
    }
    return field;
  }

  resetForm() {
    this.reset.emit();
  }

  closeModal() {
    this.close.emit();
  }
}
